<h1 class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Użytkownicy</h1>
<div class="users-card fill-column">
  <div class="users-toolbar">
    <span></span>
    <span class="users-search border-solid border-round-md border-1 p-1 border-300 flex align-items-center">
      <i class="pi pi-search mr-2 text-primary" aria-hidden="true"></i>
      <input #searchInput pInputText type="search" placeholder="Wyszukaj" aria-label="Wyszukaj użytkowników" [value]="search"
        class="p-1 border-none outline-none text-base w-full"
        (input)="onSearch(searchInput.value)">
    </span>
  </div>
  <fas-services-table class="table-height" styleClass="users-table" scrollHeight="flex" [value]="users" [columns]="columns" [rows]="rows" [first]="first"
    [rowsPerPageOptions]="[25, 50, 100]" [paginator]="true" [alwaysShowPaginator]="false"
    [showCheckbox]="false" [showEmptyColumn]="false" [loading]="loading" [lazy]="true"
    [totalRecords]="totalRecords" [footerButtonOptions]="null" [showFooterPageReport]="false" (lazyLoad)="load($event)">
    <ng-template #userEmail let-user>
      <span class="user-email">
        {{ user.email }}
        <button type="button" class="white-button user-details"
          (click)="$event.stopPropagation(); showDetails(user)" data-clarity-unmask="true">
          Szczegóły <i class="pi pi-arrow-right" aria-hidden="true"></i>
        </button>
      </span>
    </ng-template>
    <ng-template #userOsk let-user>
      <span *ngIf="user.oskName" class="user-osk" [pTooltip]="user.oskName" tooltipPosition="top">{{ user.oskName }}</span>
    </ng-template>
    <ng-template #userActions let-user>
      <button type="button" class="transparent-button appear" pTooltip="Przydziel abonament" tooltipPosition="bottom"
        aria-label="Przydziel abonament" (click)="assignSubscription(user)"><i class="pi pi-plus"></i></button>
      <button type="button" class="transparent-button appear" pTooltip="Usuń użytkownika" tooltipPosition="bottom"
        aria-label="Usuń użytkownika" (click)="deleteUser(user)"><i class="pi pi-trash"></i></button>
      <button *ngIf="user.emailConfirmed === false" type="button" class="transparent-button appear activation-link"
        pTooltip="Wyślij link aktywacyjny ponownie" tooltipPosition="bottom" aria-label="Wyślij link aktywacyjny ponownie"
        [disabled]="activationLinkPending.has(user.guid)" (click)="resendActivationLink(user)" data-clarity-unmask="true">
        <i [class]="activationLinkPending.has(user.guid) ? 'pi pi-spin pi-spinner' : 'pi pi-envelope'"></i>
      </button>
    </ng-template>
  </fas-services-table>
</div>
<p-confirmDialog key="platformUserDelete" [style]="{ width: '480px' }"></p-confirmDialog>
<p-confirmDialog key="platformUserActivationLink" [style]="{ width: '480px' }"></p-confirmDialog>
